var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-header poppins row"},[_c('div',{class:`${_vm.lg ? `col-lg-${_vm.lg}` : 'col-12'}`},[_c('h1',{staticClass:"block-header-name"},[_vm._v(" "+_vm._s(_vm._f("i18n")(_vm.name))+" "),_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }